import { useProfile } from '@/entities/profile'

/**
 * Проверяет, является ли текущий путь публичным
 */
function isPublicPath(): boolean {
  const path = window.location.pathname
  const publicPaths = ['/auth/sign-in', '/auth/sign-in-status', '/privacy-policy', '/500']
  return publicPaths.some((publicPath) => path.startsWith(publicPath))
}

/**
 * Обработчик 401 ошибки (Unauthorized)
 * Очищает профиль пользователя и перенаправляет на страницу входа
 */
export const unauthorisedErrorHandler = async (response: Response) => {
  if (isPublicPath()) {
    return response
  }

  const { logout } = useProfile()

  // Выполняем logout и редиректим на страницу входа
  await logout('/auth/sign-in')

  return response
}
